import React from 'react';
import img1 from 'assets/images/mock/activeTasks/image.png';
import img2 from 'assets/images/mock/activeTasks/image2.png';
import img3 from 'assets/images/mock/activeTasks/image3.png';
import { Col, Divider, Image, Row, Typography } from 'components';
import { ArrowRightIcon } from 'components/common/icons';
import styles from './styles.module.scss';

const taskList = [
  {
    img: img1,
  },
  {
    img: img2,
  },
  {
    img: img3,
  },
];

const { Text } = Typography;
export const ActiveTasks = React.memo(() => {
  return (
    <Row className={styles.active_tasks} align={'middle'}>
      <Col>
        <Row className={styles.title_container} wrap={false} align={'middle'}>
          <Text className={'font-weight-600'}>Active Tasks</Text>
          <Divider type={'vertical'} className={styles.divider} />
          <Text className={styles.count}>12</Text>
        </Row>
      </Col>
      <Col>
        <Row align={'middle'} className={styles.right_side}>
          <Col>
            <Row className={styles.img_container}>
              {taskList.map((_task) => (
                <Image key={_task.img} src={_task.img} alt={'Avatar'} preview={false} className={styles.avatar} />
              ))}
              <Col className={styles.avatar_counts}>
                <Text className={'font-size-12 font-weight-600'}>+7</Text>
              </Col>
            </Row>
          </Col>
          <ArrowRightIcon />
        </Row>
      </Col>
    </Row>
  );
});
